<div class="modal-body">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <div class="header">
            <h1 class="t-fw600 t-fs24 poppins">SIGN IN TO ALAMATCH</h1>
            <p class="t-fs16 poppins">Please enter your credentials</p>
          </div>
        </div>
      </div>
      <form [formGroup]="form">
        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline" class="poppins">
              <input matInput type="text" placeholder="Username" class="input" formControlName="username">
            </mat-form-field>  
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <mat-form-field appearance="outline" class="poppins">
              <input matInput [type]="show ? 'text' : 'password'" placeholder="Password" class="input" formControlName="password">
              <mat-icon matSuffix class="pointer" (click)="showPassword()">{{ show ? 'visibility_off' : 'visibility' }}
              </mat-icon>
            </mat-form-field>  
          </div>
        </div>
        <div class="row">
          <div class="col-12 t-fw400 t-fs16 text-start d-flex justify-content-between">
            <p class="forgot-text">Forgot Password?</p>
            <!-- <p class="forgot-text" (click)="openModal()">Register</p> -->
          </div>
        </div>
  
        <div class="row">
          <div class="col-12 t-fw400 t-fs16 text-start">
          </div>
        </div>
        <div class="row">
          <div class="col-12 ">
            <button class="btn login poppins" type="button" (click)="login()" [disabled]="!form.valid">LOGIN</button>
          </div>
        </div>
      </form>
    </div>
  </div>
  <!-- <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="close()">Close</button>
  </div> -->
    